import { View, ViewOpts } from '@play-co/timestep-core/ui';
import { SuperCubeBlockView } from 'src/game/minigame/match2-timestep/game/views/blocks/SupeCubeBlockView';

/**
 * The super lollipop icon for general UI, wrapping an actual super cube block view used in gameplay.
 * SuperCubeBlockView - pixi-like container, using its in-game id (cube === lollipop)
 * SuperLollipopIcon - The timestep view that we can use in UI
 */
export class SuperLollipopIcon extends View {
  constructor(opts: ViewOpts) {
    super({ ...opts, centerOnOrigin: true, width: 100, height: 100 });
    const block = new SuperCubeBlockView();
    this.addSubview(block.view);
    block.x = this.style.width / 2;
    block.y = this.style.height / 2;
  }

  public static assets() {
    return SuperCubeBlockView.assets();
  }
}
